import { useHoneyGridApiFetch } from '@/queries/useHoneyGridApiFetch'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import { workspaceQueryKey } from './useWorkspaceById'
import { workspacesQueryKey } from './useWorkspaces'

import type { Workspace } from 'honeygrid-types'

export const useUpdateWorkspace = () => {
	const queryClient = useQueryClient()
	const authFetch = useHoneyGridApiFetch()

	return useMutation({
		mutationFn: (workspace: Partial<Workspace>) =>
			authFetch(`workspaces/${workspace.id}`, {
				method: 'PATCH',
				body: workspace,
			}) as Promise<Pick<Workspace, 'id'>>,
		onSuccess: (_, variables) => {
			// Invalidate workspaces list
			queryClient.invalidateQueries({ queryKey: workspacesQueryKey() })
			// Invalidate specific workspace
			queryClient.invalidateQueries({ queryKey: workspaceQueryKey(variables.uuid!) })
		},
	})
}
